"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = default_1;
const accessibility_standards_1 = __importDefault(require("@deque/accessibility-standards"));
const common_tags_1 = require("common-tags");
const escapeHTML = (str) => String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;');
function default_1(issues, { ruleset, name, timestamp = new Date().toISOString() }) {
    const groupedByRule = issues.reduce((groupedData, issue) => {
        groupedData[issue.rule] = groupedData[issue.rule] || {
            igt: [],
            manual: [],
            automatic: []
        };
        if (issue.isManual && issue.igtTool) {
            groupedData[issue.rule].igt.push(issue);
        }
        else if (issue.isManual && !issue.igtTool) {
            groupedData[issue.rule].manual.push(issue);
        }
        else {
            groupedData[issue.rule].automatic.push(issue);
        }
        return groupedData;
    }, {});
    return (0, common_tags_1.html) `
    <?xml version="1.0" encoding="utf-8"?>
    <testsuites>
      <testsuite
        id="${ruleset ? accessibility_standards_1.default[ruleset]?.value : accessibility_standards_1.default.all.value}"
        name="${name}"
        package="Axe DevTools Browser Extension"
        timestamp="${timestamp}"
      >
        <properties>
          <property name="platform.userAgent" value="" />
          <property name="platform.testMachine" value="" />
          <property name="testSubject.fileName" value="" />
          <property name="testSubject.lineNum" value="-1" />
        </properties>
        ${Object.entries(groupedByRule)
        .map(([ruleId, ruleIssues]) => {
        return Object.entries(ruleIssues)
            .map(([type, typeIssues]) => {
            if (!typeIssues.length) {
                return '';
            }
            const firstIssue = typeIssues[0];
            let id;
            if (type === 'igt') {
                id = `igt:${firstIssue.igtTool
                    .replace(/\s+/g, '-')
                    .toLowerCase()}`;
            }
            else if (type === 'manual') {
                id = 'manual';
            }
            return (0, common_tags_1.html) `
                  <testcase name="${ruleId}" ${id ? `id="${id}"` : ''}>
                    <failure
                      message="${firstIssue.description} ${firstIssue.helpUrl}"
                      impact="${firstIssue.impact}"
                    >
                      ${typeIssues
                .map(typeIssue => {
                const selector = typeIssue.selector?.length === 1
                    ? typeIssue.selector[0]
                    : JSON.stringify(typeIssue.selector);
                const source = escapeHTML(typeIssue.source);
                return [
                    `CSS Path: ${selector}`,
                    `HTML: ${source}`
                ].join('\n');
            })
                .join('\n\n--------\n\n')}
                    </failure>
                  </testcase>
                `;
        })
            .join('\n');
    })
        .join('\n')}
      </testsuite>
    </testsuites>
  `;
}
//# sourceMappingURL=j-unit-xml.js.map